import React, {
	useEffect
}from "react"
import {
	 Modal, Form, Space
}from "antd"
import {
	useSelector
}from 'react-redux'
import CustomButton from "../../../components/CustomButton"
import CustomInput from "../../../components/CustomInput"
import Notifications from "../../../helpers/Notifications"
import DeleteIcon from '../../../components/Icons/delete.svg'
import Scrollbars from "react-custom-scrollbars"
import CustomAddButton from "../../../components/CustomAddButton"

const RePossibleCharacteristicChangeForm = ({ visible, setVisible, setRecord, record, characteristic, create, update }) => {
	const { isSending, changed } = useSelector(state => state.rePossibleCharacteristicReducer)

	const [form] = Form.useForm()

	useEffect(() => {
		form.resetFields()
		if (record){
			form.setFieldsValue({
				value          : record.value,
				characteristic : record.characteristic
			})
		}
	}, [record])

	useEffect(() => {
		if (changed)
			handleCancel()
	}, [changed])

	function handleCancel(){
		form.resetFields()
		setVisible(false)
		setRecord(null)
	}

	const save = () => {
		form.validateFields().then(values => {
			const updateValues = {
				characteristicId : characteristic,
				id               : record?.id,
				value            : record ? values.value.trim() : values.value.map(e => e.value.trim()),
				createDate       : record?.createDate
			}
			if (record ? updateValues.value === record?.value : updateValues.value.join(',') === record?.value.join(','))
				Notifications.errorNotice("Введенные вами данные полностью соответствуют изначальным.", null, 20)
			else
				record ? update(updateValues) : create(updateValues)
		})
	}

	return (
		<Modal
			destroyOnClose
			footer={ [
				<CustomButton
					key="save"
					loading={ isSending }
					type="green"
					onClick={ save }
				>
                    Сохранить
				</CustomButton>
			] }
			title={ record ? "Редактирование значения" : "Добавление значений" }
			visible={ visible }
			width={ 900 }
			onCancel={ handleCancel }
		>
			<Scrollbars
				autoHeight
				autoHide
				autoHeightMax={ 650 }
			>
				<Form
					className="possible-characteristic-form"
					form={ form }
					labelAlign="left"
					name="nsi-form"
				>
					<Form.Item
						name="value"
					>
						{ record
							? <CustomInput />
							: ((<Form.List
								name="value"
							    >
								{ (fields, { add, remove }) => (
									<>
										{ fields.map(({ key, name, ...restField }) => (
											<Space
												key={ key }
												align="baseline"
												style={ { display      : 'flex',
													marginBottom : 8 } }
											>
												<Form.Item
													{ ...restField }
													shouldUpdate
													name={ [name, 'value'] }
													rules={ [
														{ required : true,
															message  : "Пожалуйста, введите значение" }
													] }
												>
													<CustomInput placeholder="Значение" />
												</Form.Item>
												<Form.Item>
													<img
														src={ DeleteIcon }
														onClick={ () => remove(name) }
													/>
												</Form.Item>
											</Space>
										)) }
										<Form.Item>
											<CustomAddButton
												onClick={ () => add() }
											/>
										</Form.Item>
									</>
								) }
							</Form.List>)) }
					</Form.Item>
				</Form>
			</Scrollbars>
		</Modal>
	)
}
export default RePossibleCharacteristicChangeForm
